function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-Email-Nav{fill:#5b4e03;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_70",
  "data-name": "Layer 70"
}, /*#__PURE__*/React.createElement("g", {
  id: "Centre_Footer_Group",
  "data-name": "Centre Footer Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Email_Icon",
  "data-name": "Email & Icon"
}, /*#__PURE__*/React.createElement("g", {
  id: "Email"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-Email-Nav",
  d: "M16.13,16.13l-4-3.5L.73,22.42A2.3,2.3,0,0,0,2.3,23H30a2.31,2.31,0,0,0,1.54-.62L20.12,12.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-Email-Nav",
  d: "M31.53.62A2.31,2.31,0,0,0,30,0H2.3A2.29,2.29,0,0,0,.77.63l15.36,13.2Z"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-Email-Nav",
  points: "0 2.02 0 21.17 11.14 11.71 0 2.02"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-Email-Nav",
  points: "21.12 11.71 32.26 21.17 32.26 2.02 21.12 11.71"
}))))));

var SvgEmail = function SvgEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32.26 23.04",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Email.07c6697e.svg";
export { ForwardRef as ReactComponent };